import React from 'react';
import { array, bool, func, object, string, node, shape } from 'prop-types';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { I18n } from '@fiverr-private/i18n-react';
import { sessionStorage } from '@fiverr-private/futile';
import { triggerSignUp } from '@fiverr-private/identification_triggers';
import { COLLECT_SESSION_STORAGE_KEY } from '../../utils/constants';
import { createCollection, createCollectionItem, deleteFromAllCollections } from '../../actions';
import { getDefaultCollection, getDefaultCollectionName } from '../../utils/defaultCollection';
import { handleSubmitError } from '../../utils/validations';
import { contextConnect } from '../Context';
import withEducationTooltip from '../EducationTooltipWrapper';
import raiseItemCreateSuccess from '../../utils/raiseItemCreateSuccess';
import CollectTooltip from '../CollectTooltip';
import { HeartBtn } from '../ui/HeartBtn';

const CollectHeartBtn = ({
    inspireVariant = false,
    collections,
    isLoggedIn,
    resource,
    isCollected,
    createCollectionItem,
    createCollection,
    deleteFromAllCollections,
    onCollectionClickedCallback,
    onUpdateCollections,
    tooltipClassName,
    heartButtonClassName,
    heartIcon,
    triggerData = {},
    source = null
}) => {

    const onClick = async() => {
        if (!isLoggedIn) {
            sessionStorage.set(COLLECT_SESSION_STORAGE_KEY, resource.id);

            await triggerSignUp({ modalOptions: {
                ...(!isEmpty(triggerData) && { ...triggerData }),
                triggerType: 'blocked_action',
                source
            }
            });

            return;
        }

        try {
            if (isCollected) {
                await deleteFromAllCollections({ resource, onUpdateCollections });
            } else if (collections.length) {
                const { id, name } = getDefaultCollection(collections);
                await createCollectionItem({ id, resource, onUpdateCollections });

                raiseItemCreateSuccess(name);
            } else {
                const collectionName = getDefaultCollectionName();
                await createCollection({ name: collectionName, resource, onUpdateCollections });
            }
        } catch (error) {
            handleSubmitError(error);
            return;
        }

        if (onCollectionClickedCallback) {
            onCollectionClickedCallback({ isCollected, clickedComponent: 'heartBtn' });
        }
    };

    const collectionName = collections.length ?
        getDefaultCollection(collections).name :
        getDefaultCollectionName();

    const getTooltipContent = () => {
        if (!isLoggedIn) {
            return <I18n k="collect_package.save_in"/>;
        }

        if (!isCollected && !inspireVariant) {
            return <I18n k="collect_package.save_to_collection" params={{ collectionName }}/>;
        }

        return null;
    };

    return (
        <CollectTooltip content={getTooltipContent()} tooltipClassName={tooltipClassName}>
            <HeartBtn heartIcon={heartIcon} onClick={onClick} filled={isCollected} inspireVariant={inspireVariant} className={heartButtonClassName}/>
        </CollectTooltip>
    );
};

CollectHeartBtn.propTypes = {
    inspireVariant: bool,
    collections: array,
    isLoggedIn: bool,
    resource: object,
    isCollected: bool,
    createCollectionItem: func,
    createCollection: func,
    deleteFromAllCollections: func,
    onCollectionClickedCallback: func,
    onUpdateCollections: func,
    tooltipClassName: string,
    heartButtonClassName: string,
    heartIcon: node,
    triggerData: shape({
        triggerId: string,
        triggerCopy: string,
        triggerPlacement: string,
        triggerComments: string
    }),
    source: string
};

const mapStateToProps = ({ collections }) => ({ collections });

export { CollectHeartBtn };
export default compose(
    connect(mapStateToProps, {
        createCollectionItem,
        createCollection,
        deleteFromAllCollections
    }),
    contextConnect(),
    withEducationTooltip
)(CollectHeartBtn);
